import { render, staticRenderFns } from "./PhoneDisplayWidget.vue?vue&type=template&id=4e3ce58e&scoped=true&"
import script from "./PhoneDisplayWidget.vue?vue&type=script&lang=js&"
export * from "./PhoneDisplayWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ce58e",
  null
  
)

export default component.exports